export enum WindowType {
  Bot = 'bot',
  Messages = 'messages',
  Message = 'message',
  Notifications = 'notifications',
}
